<template>
    <div class="dashboard">
        <Breadcrumb :currentPage="breadcrumbName" :items="breadcrumbItems" :showAddBtn="true"/>
        <SampleCard :cards="samplesCards" :isEditable="allowEdit"/>
        <Pagination :totalPages="totalPages" @loadPage="loadSamplesInPage"/>
    </div>
</template>

<script>
    import axios from "axios";
    import Const from "../const.js";
    import Breadcrumb from '../components/common/Breadcrumb.vue';
    import SampleCard from '../components/SampleCard.vue';
    import Pagination from '../components/Pagination.vue';

    export default {
        name: 'category_detail',
        components: {
            Breadcrumb,
            SampleCard,
            Pagination,
        },
        data() {
            return {
                category: this.$route.params.category,
                allowEdit: false,
                totalPages: 0,
                currentPageNo: 1,
                breadcrumbName: '',
                breadcrumbItems: [
                    {
                        text: 'Categories',
                        disabled: false,
                        to: {path: '/'},
                        exact: true,
                    },
                ],
                samplesCards: [],
            }
        },
        methods: {
            waitMountedDialogLoader() {
                if (typeof this.$root.$dialogLoader !== "undefined") {
                    this.loadSamplesInPage(this.currentPageNo)
                } else {
                    setTimeout(this.waitMountedDialogLoader, 250);
                }
            },

            getTotalSample() {
                axios.get(Const.SERVER_ADDR + "sample/sample_count", {
                    params: {category: this.category}
                })
                    .then(response => {
                        var sampleCount = response.data.total_samples;
                        this.totalPages = Math.ceil(sampleCount / Const.ITEMS_PER_PAGE);
                    })
            },

            processSample(sample) {
                const imgPaths = sample.images.map(img => ({
                    default: img.default,
                    highlight: img.highlight,
                    path: Const.SERVER_ADDR + img.path
                }));

                return {
                    name: sample.name.replace(/_/g, " "),
                    meshUrl: Const.SERVER_ADDR + sample.meshUrl,
                    images: imgPaths
                }
            },

            loadSamplesInPage(page) {
                this.currentPageNo = page;
                this.$root.$dialogLoader.start('Loading samples ...', {color: 'primary'}, {}, true);
                axios.get(Const.SERVER_ADDR + "sample/get_samples", {
                    params: {
                        category: this.category,
                        page: page,
                        items_per_page: Const.ITEMS_PER_PAGE
                    }
                }).then(response => {
                    this.samplesCards = response.data.map(smp => this.processSample(smp));
                    this.$root.$dialogLoader.stop('Sample loaded', {color: 'primary', timeout: 10000}, {});
                }).catch(() => {
                    this.$root.$dialogLoader.stop('Error', {timeout: 10000}, {});
                })
            }
        },

        created() {
            this.breadcrumbName = this.category.charAt(0).toUpperCase() + this.category.slice(1);
            this.breadcrumbItems = this.breadcrumbItems.concat({
                text: this.breadcrumbName,
                disabled: true,
                to: {path: '/categories/' + this.category},
                exact: true,
            });
            this.getTotalSample();
            this.waitMountedDialogLoader()
        },
    }
</script>
